const estoqueOperacao = {
    ENTRADA: 1,
    SAIDA: 2,
    ESTORNO: 3,

    desc: (value) => {
        switch(value){
            case 1:
                return 'Entrada';
            
            case 2:
                return 'Saída';

            case 3:
                return 'Estorno';
            
        }
    }
}

export default estoqueOperacao;